var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunctionStruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 20.491008 20.491008",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "cursor-pointer border-1 border-gray-300 rounded-md px-1",
    height: 37.566849,
    width: 37.566849,
    id: "svg10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 1.2455046,17.245505 a 2,2 0 0 0 2,2 c 2,0 2,-4 3,-9 1,-5.0000004 1,-9.0000004 3,-9.0000004 a 2,2 0 0 1 2.0000004,2",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 3.2455046,10.245505 h 6",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 13.245505,10.245505 6,6",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 13.245505,16.245505 6,-6",
    id: "path8"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillRule: "evenodd",
      strokeWidth: 2.33284,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 20.43698,0.05402773 0.05402773,20.43698",
    id: "path390"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionStruck);
export default __webpack_public_path__ + "static/media/function_struck.6aaaf70bd22bd92b90b7f7589011be5d.svg";
export { ForwardRef as ReactComponent };